import React from 'react'

import Box from '@mui/material/Box'

import { useInView } from 'react-intersection-observer'

interface PulseProgressBarProps {
  backgroundColor?: string
  color: string
  percent: number
  height: number
}

export const PulseProgressBar: React.FC<PulseProgressBarProps> = ({
  backgroundColor,
  color,
  percent,
  height = 12,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true })
  const [barWidth, setBarWidth] = React.useState('0%')

  const roundedPercent = percent > 100 ? 100 : percent

  React.useEffect(() => {
    if (inView) {
      setBarWidth(`${roundedPercent}%`)
    }
  }, [inView, roundedPercent])

  return (
    <React.Fragment>
      <Box
        data-ui-test="progress-bar"
        ref={ref}
        sx={{
          position: 'relative',
          borderRadius: 8,
          height,
          width: '100%',
        }}
      >
        <Box
          sx={{
            borderRadius: 8,
            bgcolor: backgroundColor ? backgroundColor : color,
            height: '100%',
            opacity: backgroundColor ? 1 : 0.4,
            position: 'absolute',
            width: '100%',
          }}
        />
        <Box
          sx={{
            bgcolor: color,
            borderRadius: 8,
            height: '100%',
            position: 'absolute',
            transition: 'width .4s cubic-bezier(0.28, 0.14, 0.34, 1.04)',
            width: barWidth,
          }}
        />
      </Box>
    </React.Fragment>
  )
}
